import styled from 'styled-components';

const Image = styled.div`
  min-width: 250px;
  width: 100%;
  max-width: 450px;
  height: 600px;
  margin-bottom: ${(props) => props.marginBottom};
  flex: 0 1 auto;
  img {
    width: 100%;
    height: 100%;
  }
`;

export default Image;
